import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Instagram } from 'lucide-react';
import { companyInfo } from '../mockData';

export const Footer = () => {
  return (
    <footer className="bg-[#004494] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-12 bg-[#FFD617] rounded-lg flex items-center justify-center">
                <span className="text-[#004494] font-bold text-xl">HCS</span>
              </div>
              <h3 className="text-xl font-bold font-heading">{companyInfo.name}</h3>
            </div>
            <p className="text-sm text-gray-200 mb-4">{companyInfo.tagline}</p>
            <p className="text-sm text-gray-300">
              Specializing in customized electrical control panels with complete end-to-end solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4 font-heading">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-sm text-gray-200 hover:text-[#FFD617] transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/products"
                  className="text-sm text-gray-200 hover:text-[#FFD617] transition-colors"
                >
                  Products & Services
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="text-sm text-gray-200 hover:text-[#FFD617] transition-colors"
                >
                  Portfolio
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm text-gray-200 hover:text-[#FFD617] transition-colors"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Details */}
          <div>
            <h4 className="text-lg font-semibold mb-4 font-heading">Contact Details</h4>
            <div className="space-y-4">
              <div>
                <p className="text-sm font-medium text-[#FFD617] mb-1">Founder / CEO</p>
                <p className="text-sm text-gray-200">{companyInfo.founder}</p>
              </div>
              <div className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-[#FFD617] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm text-gray-200">{companyInfo.phone}</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-[#FFD617] mt-0.5 flex-shrink-0" />
                <div>
                  <a
                    href={`mailto:${companyInfo.email}`}
                    className="text-sm text-gray-200 hover:text-[#FFD617] transition-colors break-all"
                  >
                    {companyInfo.email}
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#FFD617] mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-sm font-medium text-gray-200">Address</p>
                  <p className="text-sm text-gray-300">{companyInfo.address}</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <a
                  href={companyInfo.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center space-x-2 text-sm text-gray-200 hover:text-[#FFD617] transition-colors"
                >
                  <Instagram className="w-5 h-5" />
                  <span>Follow us on Instagram</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-600">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-sm text-gray-300">
              © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
            </p>
            <p className="text-sm text-gray-300">
              Designed for Industrial Excellence
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};